import React, {Component} from 'react';
import {connect} from 'react-redux';
import { bindActionCreators } from 'redux';

import DietSwitcher from './../../components/DietSwitcher/DietSwitcher';
import * as actionTypes from './../../store/actions/dietAction';
import fetchDietAction from './../../store/actions/fetch/fetchDietAction';
import Loader from './../../components/Loader/Loader'
import DietCardsRemover
  from "../../components/DietCardsRemover/DietCardsRemover";

/**
 * Diet container
 */
class Diet extends Component {
  componentDidMount() {
    const {fetchData} = this.props;
    fetchData();
  }

  render() {
    const {data, error, pending, selected, onSelect, defaultValues, ready,
      onRemove, readyAnimalType, selectedAnimalType, animalType} = this.props;

    // If there is a need for default data
    if(!ready && !error && !pending && readyAnimalType) {
      defaultValues(selectedAnimalType);
    }
    // If there is a need for default data
    if(ready && selectedAnimalType !== animalType) {
      defaultValues(selectedAnimalType);
    }
    // If Animal type data is pending
    if(pending || !ready) return (
      <Loader/>
    );
    // Return switcher
    return (
      <div className='nppe2-fc-diet-switcher__wrapper'>
        {error && <span className='nppe2-fc-diet-switcher__error'>{error}</span>}
        {!error &&
        <DietSwitcher data={data} type={selectedAnimalType} selected={selected} onSelect={onSelect}/>}
        {!error &&
        <DietCardsRemover data={data} type={selectedAnimalType}  selected={selected} onRemove={onRemove}/>}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    selected: state.dietReducer.selected,
    error: state.dietReducer.error,
    data: state.dietReducer.data,
    pending: state.dietReducer.pending,
    ready: state.dietReducer.ready,
    readyAnimalType: state.animalTypeReducer.ready,
    selectedAnimalType: state.animalTypeReducer.animalType,
    animalType: state.dietReducer.animalType,
  }
};

const mapDispatchToProps = dispatch => {
  return {
    ...bindActionCreators({
      fetchData: fetchDietAction
    }, dispatch),
    onSelect: (id) => dispatch({
      type: actionTypes.SELECT,
      selected: id,
    }),
    onRemove: (id) => dispatch({
      type: actionTypes.REMOVE,
      removed: id,
    }),
    defaultValues: (animalType) => dispatch({
      type: actionTypes.DEFAULT,
      animalType: animalType,
    }),
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(Diet);
